import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DossieRepository, DOSSIER_REPOSITORY } from '../repositories/dossie.repository';

@Injectable({
  providedIn: 'root'
})
export class ExcluirDossieUseCase {
  constructor(
    @Inject(DOSSIER_REPOSITORY) private readonly repository: DossieRepository
  ) {}

  execute(id: number): Observable<void> {
    return this.repository.excluirDossie(id);
  }
}
